(() => {
  'use strict';

  const CONFIG = Object.freeze({
    experimentId: 'rec_v1_20260921',
    storageKey: 'sct_rec_experiment_v1',
    control: 'control',
    treatment: 'treatment',
    treatmentRatio: 0.5,
  });

  const query =
    new URLSearchParams(
      window.location.search
    );

  const debug =
    query.get('sct_debug') === '1';

  const forced =
    query.get(
      'sct_rec_variant'
    );

  const isPreview =
    query.has(
      'preview_theme_id'
    ) ||
    Boolean(
      window.Shopify?.designMode
    );

  function safeParse(value) {
    if (!value) return null;

    try {
      return JSON.parse(value);
    } catch (_error) {
      return null;
    }
  }

  function randomNumber() {
    try {
      const values =
        new Uint32Array(1);

      crypto.getRandomValues(
        values
      );

      return (
        values[0] /
        4294967296
      );
    } catch (_error) {
      return Math.random();
    }
  }

  function readStored() {
    try {
      const parsed =
        safeParse(
          localStorage.getItem(
            CONFIG.storageKey
          )
        );

      if (
        !parsed ||
        parsed.experimentId !==
          CONFIG.experimentId ||
        ![
          CONFIG.control,
          CONFIG.treatment,
        ].includes(
          parsed.group
        )
      ) {
        return null;
      }

      return parsed;
    } catch (_error) {
      return null;
    }
  }

  function persist(
    group,
    assignedAt
  ) {
    try {
      localStorage.setItem(
        CONFIG.storageKey,
        JSON.stringify({
          experimentId:
            CONFIG.experimentId,
          group,
          assignedAt,
        })
      );
    } catch (_error) {
      // no-op
    }
  }

  let group = '';
  let source = '';
  let assignedAt =
    new Date().toISOString();

  if (
    forced === CONFIG.control ||
    forced === CONFIG.treatment
  ) {
    group = forced;
    source = 'query_override';
  } else if (isPreview) {
    group =
      CONFIG.treatment;

    source =
      'preview_treatment';
  } else {
    const stored =
      readStored();

    if (stored) {
      group =
        stored.group;

      assignedAt =
        stored.assignedAt ||
        assignedAt;

      source =
        'stored';
    } else {
      group =
        randomNumber() <
        CONFIG.treatmentRatio
          ? CONFIG.treatment
          : CONFIG.control;

      source =
        'random_50_50';

      persist(
        group,
        assignedAt
      );
    }
  }

  const assignment =
    Object.freeze({
      id:
        CONFIG.experimentId,
      group,
      source,
      assignedAt,
      isPreview,
    });

  window
    .SctRecommendationExperiment =
      Object.freeze({
        ...assignment,

        isTreatment() {
          return (
            group ===
            CONFIG.treatment
          );
        },

        isControl() {
          return (
            group ===
            CONFIG.control
          );
        },

        getAssignment() {
          return assignment;
        },

        reset() {
          if (!debug) {
            return false;
          }

          try {
            localStorage
              .removeItem(
                CONFIG.storageKey
              );

            return true;
          } catch (_error) {
            return false;
          }
        },
      });

  document.documentElement
    .dataset
    .sctRecExperiment =
      group;

  if (debug) {
    console.log(
      '[SCT Recommendation Experiment]',
      assignment
    );
  }
})();